import { render, staticRenderFns } from "./commissions.vue?vue&type=template&id=c65f59ec&scoped=true&"
import script from "./commissions.vue?vue&type=script&lang=ts&"
export * from "./commissions.vue?vue&type=script&lang=ts&"
import style0 from "./commissions.vue?vue&type=style&index=0&id=c65f59ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c65f59ec",
  null
  
)

export default component.exports